import React, {useEffect, useState} from "react";
import {ConvertTMonthName} from "../../Services";
import moment from "moment-jalaali";
import {ConvertToJalali} from "../StoreDetail/StoreDetailServices";
import Rodal from "rodal";
import {TicketsData, WinnerData} from "./FestivalDetailServices";




function LotteryCard({lot}) {
    const [countDown,set_countDown] = useState("");
    const [showModal,set_showModal] = useState(false);
    const [showTicketsModal,set_showTicketsmodal] = useState(false);
    const [winners,set_winners] = useState([]);
    const [tickets,set_tickets] = useState([]);

    useEffect(()=>{
        switch (lot.status) {
            case 'normal' :
                ConvertToJalaliSplited(lot.lottery_time)
                break;
            case 'generated_code' :
                ConvertToCounDown(lot.lottery_time)
                break;
            case 'auto_executed' :

                break;
            case 'manual_executed' :

                break;
        }

    },[])

    const component = (x, v) => {
        return Math.floor(x / v);
    }

    const countD = (timestamp)=>{
        timestamp /= 1000; // from ms to seconds
        setInterval(() => {
            timestamp--;
            let days    = component(timestamp, 24 * 60 * 60),
                hours   = component(timestamp,      60 * 60) % 24,
                minutes = component(timestamp,           60) % 60,
                seconds = component(timestamp,            1) % 60;

            let day_u = days + " روز  -  ";
            if(days===0){
                day_u = ""
            }
            set_countDown(day_u + hours + ":" + minutes + ":" + seconds)
        }, 1000);
    }


    const ConvertToJalaliSplited = (date) =>{
        let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        set_countDown(day+" "+month+""+year)
    }

    const ConvertToCounDown = (date) =>{
        let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        let lotStamp = new Date(date).getTime() / 1000;
        let nowStamp = new Date().getTime()/1000;
        let left = (lotStamp*1000) - (nowStamp*1000);
        let hours = (left / (1000 * 60 * 60));
        let timestamp = (Date.now() + 1000 * 60 * 60 * hours) - Date.now();
        countD(timestamp)
    }

    const convertStatus = (status) =>{
        let res = ""
        switch (status) {
            case 'normal' :
                res = "در حال برگزاری";
                break;
            case 'generated_code' :
                res = "فرصت شرکت تمام شده";
                break;
            case 'auto_executed' :
                res = "اتمام قرعه کشی";
                break;
            case 'manual_executed' :
                res = "اتمام قرعه کشی";
                break;
        }

        return res;
    }

    const showWinner = async (lot) =>{
        //get Winners
        try{
            const winnersResponse = await WinnerData(lot.uid);
            set_winners(winnersResponse.data)
            set_showModal(true)
        }catch (e) {
            // console.log(e)
        }
    }

    const showTickets = async (lot) =>{
        //get Tickets
        try{
            const ticketsResponse = await TicketsData(lot.uid);
            set_tickets(ticketsResponse.data)
            set_showTicketsmodal(true)
        }catch (e) {
            console.log(e)
        }
    }


    return(
        <div className="lottery-card">

            <Rodal animation={"zoom"} visible={showTicketsModal} onClose={()=>set_showTicketsmodal(false)}>
                <div className="winner_modal-header">
                    کدها
                </div>
                <div className="winner-modal-list">
                    {tickets.map(tick=>{
                        return(
                            <div className="winner-modal-card">
                                <div className="info">
                                    <span>{tick.code}</span>
                                    {/*<span className="reward">{tick.value}</span>*/}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Rodal>

            <Rodal animation={"zoom"} visible={showModal} onClose={()=>set_showModal(false)}>
                <div className="winner_modal-header">
                    اسامی برندگان
                </div>
                <div className="winner-modal-list">
                    {winners.map(win=>{
                        return(
                            <div className="winner-modal-card">
                                <div className="info">
                                    <span>{win.user.first_name+" "+win.user.last_name}</span>
                                    <span className="reward">{win.reward}</span>
                                </div>
                                <img src={win.user.image} alt=""/>
                            </div>
                        )
                    })}
                </div>
            </Rodal>
            <div className="lottery-header">
                <img src={lot.image} alt=""/>
                {lot && lot.status==="generated_code"? <span
                    onClick={()=>{showTickets(lot)}}
                    className="lottery-card-action">نمایش کدها</span>:null}

                {lot && lot.status==="auto_executed" || lot && lot.status==="manual_executed "? <span
                    onClick={()=>{showWinner(lot)}}
                    className="lottery-card-action">نمایش برنده ها</span>:null}
            </div>
            <div className="lottery-body">
                <div className="point">
                    <span>امتیاز شما : </span>
                    <span>{lot.score?lot.score:0}</span>
                </div>
                <span className="title">{lot.title}</span>
            </div>
            {lot && lot.status==="generated_code"?
                <div className="lottery-footer">
                <span>زمان مانده تا اجرای قرعه کشی </span>
                <span className="value">{countDown}</span>
            </div>:null}

            {lot && lot.status==="normal"?
            <div className="lottery-footer">
                <span>تاریخ قرعه کشی</span>
                <span className="value">{countDown}</span>
            </div>:null}

            <div className="lottery-status">
                <span>{convertStatus(lot.status)}</span>
            </div>

        </div>
    )

}


export {LotteryCard};
